import {api2Endpoint} from 'app/config/apiConfig'
import {UserProfile} from 'app/modules/auth/core/_models'
import {queryClient} from 'app/react-query'
import {useMutation} from 'react-query'
import {putData} from '../api/usePutData'
import {announceReturn, announceSend} from '../api/utils/announce'
import errorNotify from '../api/utils/errorNotify'

interface UpdateUserArgs {
  userId?: string
  rel: 'user'
  profile: UserProfile
  invalidateKeys?: string | Array<string>
}

export function useUpdateUserProfile(errMsg = 'Failed to update user profile') {
  return useMutation(async (args: UpdateUserArgs) => {
    try {
      if (args.userId === undefined) {
        throw Error(`User ID not found.`)
      }

      const route = `std/user/${args.userId}`
      announceSend('put', route, args.userId)
      const retval = await putData<unknown>(api2Endpoint(route), {
        profile: args.profile,
      })
      announceReturn('put', route, args.userId)
      queryClient.invalidateQueries([`user`])
      if (args.invalidateKeys) {
        typeof args.invalidateKeys === 'string'
          ? queryClient.invalidateQueries(args.invalidateKeys)
          : args.invalidateKeys.map((ik) => {
              queryClient.invalidateQueries(ik)
            })
      }
      return retval
    } catch (err) {
      errorNotify(err, errMsg)
    }
  })
}
